import React from 'react';
import { Link } from 'react-router-dom';
import { FiShieldOff } from 'react-icons/fi';

export default function Forbidden() {
  return (
    <div className="page">
      <div className="card">
        <div className="card-body" style={{ textAlign: 'center', padding: 60 }}>
          <FiShieldOff style={{ fontSize: 56, color: 'var(--warning)', marginBottom: 16 }} />
          <h2 style={{ fontSize: 24, marginBottom: 8 }}>403 — Not Authorized</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
            You do not have permission to access this page.
          </p>
          <Link to="/" className="btn btn-primary">Back to Dashboard</Link>
        </div>
      </div>
    </div>
  );
}